import { render, staticRenderFns } from "./riCedantInfo.vue?vue&type=template&id=76a4910c&"
import script from "./riCedantInfo.vue?vue&type=script&lang=js&"
export * from "./riCedantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports